@if (authStore.hasModule(module())) {
  <onyx-link [color]="color()" [font]="font()" (click)="linkClick.emit()">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </onyx-link>
} @else {
  <span [class]="font()">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </span>
}

<ng-template #contentTemplate><ng-content></ng-content></ng-template>
